<template>
  <div class="modal-mask">
    <div class="modal-wrapper">
      <div class="modal-container">
        <h3>{{ modalTitle }}</h3>
        <form @submit.prevent="submitForm">
          <div class="form-group">
            <label>{{ $t('date') }} <span class="text-danger">*</span></label>
            <input v-model="form.date" type="date" class="form-control" required>
          </div>

          <div class="form-group">
            <label>{{ $t('project') }} <span class="text-danger">*</span></label>
            <select v-model="form.project_id" @change="onProjectChange" class="form-control" required>
              <option value="">Select Project</option>
              <option v-for="project in projects" :key="project.id" :value="project.id">
                {{ project.title }}
              </option>
            </select>
          </div>

          <div class="form-group">
            <label>{{ $t('client') }}</label>
            <select v-model="form.client_id" class="form-control" :disabled="!form.project_id">
              <option value="">Select Client</option>
              <option v-for="client in clients" :key="client.id" :value="client.id">
                {{ client.name }}
              </option>
            </select>
          </div>

          <div class="form-group">
            <label>{{ $t('payment_amount') }} <span class="text-danger">*</span></label>
            <input v-model="form.payment_amount" type="number" step="0.01" class="form-control" required>
          </div>

          <div class="form-group mb-3">
            <label>{{ $t('description') }} (Optional)</label>
            <textarea v-model="form.description" class="form-control" rows="3"></textarea>
          </div>

          <div class="alert alert-info" v-if="!payment">
            <small>Note: This payment will automatically create an income entry for the selected project.</small>
          </div>

          <div class="text-end mt-3">
            <button 
              class="btn btn-primary" 
              type="submit" 
              :disabled="isSubmitting">
              {{ isSubmitting ? $t('saving') + '...' : $t('save') }}
            </button>
            <button class="btn btn-secondary" type="button" @click="$emit('input', false)" :disabled="isSubmitting">
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: Boolean,
    payment: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      form: {
        date: '',
        project_id: '',
        client_id: '',
        payment_amount: '',
        description: ''
      },
      projects: [],
      clients: [],
      isSubmitting: false
    }
  },
  watch: {
    payment: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.form = {
            date: newVal.date ? newVal.date.slice(0, 10) : '',
            project_id: newVal.project_id || '',
            client_id: newVal.client_id || '',
            payment_amount: newVal.payment_amount || '',
            description: newVal.description || ''
          }
          // Load clients for the selected project if exists
          if (this.form.project_id) {
            this.fetchClients(this.form.project_id)
          }
        } else {
          this.resetForm()
        }
      }
    },
    'form.project_id': function(newVal) {
      if (newVal) {
        this.fetchClients(newVal)
      } else {
        this.clients = []
        this.form.client_id = ''
      }
    }
  },
  computed: {
    modalTitle() {
      return this.payment ? 'Edit Project Payment' : 'Add Project Payment'
    }
  },
  mounted() {
    this.fetchProjects()
  },
  methods: {
    fetchProjects() {
      axios.get('/project-payments/projects').then(res => {
        this.projects = res.data
      })
    },
    resetForm() {
      this.form = {
        date: '',
        project_id: '',
        client_id: '',
        payment_amount: '',
        description: ''
      }
      this.clients = []
    },
    onProjectChange() {
      // Reset client when project changes
      this.form.client_id = ''
      if (this.form.project_id) {
        this.fetchClients(this.form.project_id)
      } else {
        this.clients = []
      }
    },
    fetchClients(projectId) {
      axios.get('/project-payments/clients', {
        params: { project_id: projectId }
      }).then(res => {
        this.clients = res.data
      }).catch(err => {
        console.error(err)
        this.clients = []
      })
    },
    submitForm() {
      this.isSubmitting = true
      const url = this.payment ? `/project-payments/${this.payment.id}` : '/project-payments'
      const method = this.payment ? 'PUT' : 'POST'

      axios({
        method: method === 'PUT' ? 'POST' : 'POST',
        url: url,
        data: method === 'PUT' ? { ...this.form, _method: 'PUT' } : this.form
      })
        .then(() => {
          this.$emit('input', false)
          this.$emit('saved')
          this.resetForm()
          Swal.fire({
            title: 'Saved!',
            text: 'Payment saved successfully! Income entry has been ' + (this.payment ? 'updated' : 'created') + ' automatically.',
            icon: 'success',
            confirmButtonColor: '#3085d6'
          })
        })
        .catch(err => {
          console.error(err)
          Swal.fire({
            title: 'Error!',
            text: 'Error saving payment',
            icon: 'error',
            confirmButtonColor: '#3085d6'
          })
        })
        .finally(() => {
          this.isSubmitting = false
        })
    }
  }
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0; left: 0; right: 0; bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}
.modal-wrapper {
  width: 500px;
  background: #fff;
  padding: 20px;
  border-radius: 6px;
}
</style>

